
export const INPUT_NUMBER_DATA = {
    INPUT_1: {
        id: 0,
        name: 'INPUT 1'
    },
    INPUT_2: {
        id: 1,
        name: 'INPUT 2'
    },
    INPUT_3: {
        id: 2,
        name: 'INPUT 3'
    },
    INPUT_4: {
        id: 3,
        name: 'INPUT 4'
    }
}

export const INPUT_DATA = {
    hidSioId: null,
    name: null,
    number: null,
    controllerId: null,
    typeConnection: null,
    function: null,
    toAddEdit: function () {
        return {
            hidSioId: this.hidSioId,
            name: this.name,
            number: this.number,
            typeConnection: this.typeConnection,
            function: this.function
        };
    },
    isValid: function () {
        return this.hidSioId !== null &&
            this.name !== null &&
            this.name !== '' &&
            this.number !== null &&
            this.controllerId !== null &&
            this.typeConnection !== null &&
            this.function !== null;
    },
    setToTable: function (data, sioName) {
        return {
            id: data.id,
            hidSioId: data.hidSioId,
            hidSioName: sioName,
            name: data.name,
            number: data.number,
            deviceType: data.deviceType,
            sioType: data.sioType,
            typeConnection: data.typeConnection,
            function: data.function
        }
    }
};

// Keyed by the code sent to the backend (HidInputTypeConnection code)
export const CONNECTION_TYPE_MODEL = {
    0: {
        id: 0,
        name: "NC_UNSUPERVISED",
        trans: "normally_closed"
    },
    1: {
        id: 1,
        name: "NO_UNSUPERVISED",
        trans: "normally_open"
    },
    2: {
        id: 2,
        name: "SUPERVISED_NORMAL_1K_ACTIVE_2K",
        trans: "supervised_normal_1k_active_2k"
    },
    3: {
        id: 3,
        name: "SUPERVISED_NORMAL_2K_ACTIVE_1K",
        trans: "supervised_normal_2k_active_1k"
    }
}

// The inputs are read with the HidInputTypeConnection name, while older records may bring its code
export const getConnectionTypeTrans = (typeConnection) =>
    Object.values(CONNECTION_TYPE_MODEL)
        .find((item) => item.id === typeConnection || item.name === typeConnection)?.trans;

// Keyed by the HidInputFunction value, which is sent to the backend as is
export const INPUT_FUNCTION_MODEL = {
    UNUSED: {
        id: "UNUSED",
        trans: "unused"
    },
    DOOR_CONTACT: {
        id: "DOOR_CONTACT",
        trans: "door_contact"
    },
    REX: {
        id: "REX",
        trans: "rex"
    },
    GENERIC_ALARM: {
        id: "GENERIC_ALARM",
        trans: "generic_alarm"
    },
    CABINET_TAMPER: {
        id: "CABINET_TAMPER",
        trans: "cabinet_tamper"
    },
    AC_POWER_FAIL: {
        id: "AC_POWER_FAIL",
        trans: "ac_power_fail"
    },
    BATTERY_FAIL: {
        id: "BATTERY_FAIL",
        trans: "battery_fail"
    }
}
